import React from 'react';
import { useParams } from 'react-router-dom';

import { fieldObjectArps } from './auxiliarArps';
import SubAbasArps from './subabasArps';
import DestaquesComponente from '../../../../components/Destaques';
import { ENTITY } from '../../../../utils/entityNames';

const ArpsDestaques: React.FC = () => {
  const params = useParams();
  const fichaID = String(params.id);

  return (
    <DestaquesComponente
      tab="arp"
      id_tab={fichaID}
      retorno="/daf/proaq/arps"
      arquivo_export="sisaf_arp_destaques.xlsx"
      fieldObject={fieldObjectArps}
      subAbas={fichaID !== 'undefined' ? SubAbasArps(fichaID) : SubAbasArps}
      entity={ENTITY.ENTITY_Arp}
    />
  );
};

export default ArpsDestaques;
